export default {
  title: 'Raport semnat / live',
  column_groups: {
    current_period: 'Perioada curentă',
  },
  fields: {
    name: 'Nume',
    area: 'Zonă',
    signed: 'Semnat',
    live: 'Live',
    going_live: 'În curs de lansare',
    going_live_avg: 'Medie lansare',
    churned: 'Reziliat',
    not_live: 'Nu este live',
    live_ratio: 'Rată live',
    avg_mrr: 'MRR mediu',
  },
  manager_status_filters: {
    active: 'Activ',
    inactive: 'Inactiv',
    all: 'Toate',
  },
  status_filters: {
    all: 'Toate',
    not_live: 'Nu este live',
  },
  drawer: {
    title: '{{column}} — {{managerName}}',
    subtitle_one: '{{count}} restaurant',
    subtitle_few: '{{count}} restaurante',
    subtitle_other: '{{count}} restaurante',
    empty: 'Niciun restaurant găsit.',
  },
  toasts: {
    failed_to_load_data: 'Eroare la încărcarea datelor, vă rugăm reîncărcați pagina',
  },
};
